import {ComposableMap, Geographies, Geography} from 'react-simple-maps'

export const AnalyticsWorldMap = ({accessLocations}: {accessLocations: string[]}) => {
  return (
    <div style={{width: '100%', maxHeight: '175px'}}>
      <div style={{width: '100%', maxHeight: '175px'}}>
        <ComposableMap style={{width: '100%', height: '400px'}}>
          <Geographies geography='/features.json'>
            {({geographies}) =>
              geographies.map((geo: any) => {
                const countryName = geo.properties.name
                const isIndia = countryName === 'India'
                const isOtherCountry = accessLocations && accessLocations.length > 0 ? accessLocations.includes(countryName) : false

                // Determine the color based on conditions
                const fillColor =
                  isIndia && accessLocations && accessLocations.length > 0 && accessLocations.includes('India')
                    ? '#4776E6'
                    : isOtherCountry
                    ? '#062EC6'
                    : 'white'

                return (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    style={{
                      default: {
                        fill: fillColor,
                        stroke: '#CECECE',
                        strokeWidth: 1,
                        outline: '#CECECE',
                      },
                      hover: {
                        fill: '#D4DFF9',
                        outline: '#4776E6',
                      },
                      pressed: {
                        // Add a pressed style
                        fill: '#D4DFF9',
                        outline: '#4776E6',
                      },
                    }}
                  />
                )
              })
            }
          </Geographies>
        </ComposableMap>
      </div>
    </div>
  )
}
